export default "__VITE_ASSET__lHLvM79L__"